import React from 'react'

import HHConfirmDialog from 'components/common/HHConfirmDialog'
import T from 'T'

type NoBillingEmailDialogProps = {
  isOpen: boolean
  onClose: () => void
}

const CONFIRM_BUTTON_PROPS = { color: 'primary' }

const NoBillingEmailDialog = ({ isOpen, onClose }: NoBillingEmailDialogProps) => (
  <HHConfirmDialog
    ConfirmButtonProps={CONFIRM_BUTTON_PROPS}
    confirmButtonTitle={T.GOT_IT}
    confirmDescription={
      <>
        {T.NO_BILLING_EMAIL_ADD_CONTACT_LEAD}
        <strong>{T.CONTACTS}</strong>
        {T.NO_BILLING_EMAIL_ADD_CONTACT_TAIL}
      </>
    }
    confirmTitle={T.NO_BILLING_EMAIL_TITLE}
    isOpen={isOpen}
    showCancelButton={false}
    showCloseIconButton={false}
    onClose={onClose}
    onConfirm={onClose}
  />
)

export default NoBillingEmailDialog
